<template>
  <div class="pt-3">
    <v-card flat class="pa-5 rounded-lg">
      <title-page
        :back="true"
        colorIconBack="#006341"
        :title="`TSA Managemant ${
          !loading ? `${nameCategoryTsa} - ${dataSet.title}` : ''
        }`"
      />

      <p class="mt-2">
        {{ dataSet ? dataSet.description : "" }}
      </p>
      <v-skeleton-loader
        class="rounded-lg"
        height="50px"
        v-if="loading"
        type="image"
      ></v-skeleton-loader>
      <v-card
        v-if="!loading && dataSet"
        flat
        color="rgba(0, 99, 65, 0.2)"
        class="pa-3 d-flex align-center rounded-lg"
      >
        <v-icon color="#006341">mdi-calendar-blank</v-icon>
        <h4 class="notBold ml-3" style="color: #006341">
          Execute Date: &nbsp;
          <span
            ><b>{{
              $date(dataSet.start_date).format("dddd, DD MMMM YYYY")
            }}</b></span
          >
        </h4>
      </v-card>
    </v-card>
    <div>
      <v-card
        v-if="!loading && progressProposalTsa"
        flat
        class="mt-5 pa-5 rounded-lg"
      >
        <div class="d-flex align-start">
          <v-icon color="#006341">mdi-trending-up</v-icon>
          <div class="ml-3" style="width: 100%">
            <h4>Your Progress</h4>
            <p>You can watch progress of your submission below</p>

            <v-card class="mt-3" outlined>
              <v-timeline align-top dense>
                <v-timeline-item
                  v-for="(item, i) in progressProposalTsa"
                  :key="i"
                  :color="
                    item.data.status == 'submitted'
                      ? '#006341'
                      : item.data.status == 'approved'
                      ? '#006341'
                      : item.data.status == 'declined'
                      ? 'red'
                      : item.data.status == 'revision'
                      ? '#B3A369'
                      : '#B3A369'
                  "
                  :icon="
                    item.data.status == 'submitted'
                      ? 'mdi-check'
                      : item.data.status == 'approved'
                      ? 'mdi-check'
                      : item.data.status == 'declined'
                      ? 'mdi-close'
                      : item.data.status == 'revision'
                      ? 'mdi-minus'
                      : 'mdi-cached'
                  "
                  small
                  fill-dot
                >
                  <v-expansion-panels accordion flat>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="pa-0">
                        <div>
                          <b>{{ item.data.title }}</b>
                          <div>
                            <p
                              v-if="item.data.timestamp"
                              class="default_txt mt-1"
                            >
                              {{
                                $date(item.data.timestamp)
                                  .locale("id")
                                  .format("DD, MMMM, YYYY HH:mm")
                              }}
                            </p>
                            <v-icon small v-else class="mt-1">
                              mdi-progress-clock
                            </v-icon>
                          </div>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <!-- ==> ==> ==> ==> ==> ==> ==> ==> ==> ==> ==> ==> ==> ==> ==> PROGRES CONTENT -->
                        <v-card class="pa-2" flat color="#00634166">
                          <div
                            v-if="
                              item.key == 'submit_letter' ||
                              item.key == 'submit_proposal'
                            "
                          >
                            <h4 class="color_default">
                              {{
                                item.key == "submit_letter"
                                  ? "Cover Letter has been submitted"
                                  : "Proposal has been submitted"
                              }}
                            </h4>
                            <p class="color_default">
                              {{
                                item.key == "submit_letter"
                                  ? "The cover letter has been received on "
                                  : "The proposal has been received on "
                              }}
                              {{
                                $date(item.data.timestamp).format(
                                  "DD, MMMM, YYYY HH:mm",
                                )
                              }}
                            </p>
                          </div>
                          <div v-if="item.key == 'review_letter'">
                            <div v-if="item.data.status == 'process'">
                              <h3 class="color_default">No reviews yet!</h3>
                              <p class="mb-0 color_default">
                                Please wait for a review from admin
                              </p>
                            </div>
                            <v-card
                              class="pa-2"
                              v-if="item.data.status !== 'process'"
                              flat
                            >
                              <v-row no-gutters>
                                <v-col cols="1">Status</v-col>
                                <v-col cols="11">
                                  <v-chip
                                    :color="
                                      item.data.status == 'submitted'
                                        ? '#006341'
                                        : item.data.status == 'approved'
                                        ? '#006341'
                                        : item.data.status == 'declined'
                                        ? 'red'
                                        : item.data.status == 'revision'
                                        ? '#B3A369'
                                        : '#B3A369'
                                    "
                                    label
                                    text-color="white"
                                  >
                                    {{ item.data.status }}
                                  </v-chip></v-col
                                >
                                <v-col cols="1">Notes</v-col>
                                <v-col cols="11">{{ item.data.notes }}</v-col>
                              </v-row>
                              <v-btn
                                v-if="item.data.status == 'revision'"
                                @click="updateCoverLetter(item)"
                                dark
                                color="var(--g)"
                                class="text-capitalize mt-2"
                                >Update Cover Letter</v-btn
                              >
                              <v-btn
                                v-if="
                                  item.data.status == 'approved' &&
                                  progressProposalTsa.length < 3
                                "
                                @click="createProposal"
                                dark
                                color="var(--g)"
                                class="text-capitalize mt-2"
                                >Submit Proposal</v-btn
                              >
                            </v-card>
                            <v-divider class="mt-2"></v-divider>
                            <v-btn
                              dark
                              color="var(--g)"
                              class="text-capitalize mt-2"
                              @click="fetchHistory('letter', 'history')"
                              ><v-icon class="mr-2"
                                >mdi-clipboard-text-clock</v-icon
                              >
                              View History</v-btn
                            >
                          </div>
                          <div v-if="item.key == 'review_proposal'">
                            <div v-if="item.data.status == 'process'">
                              <h3 class="color_default">No reviews yet!</h3>
                              <p class="mb-0 color_default">
                                Please wait for a review from admin
                              </p>
                            </div>
                            <v-card
                              class="pa-2"
                              v-if="item.data.status !== 'process'"
                              flat
                            >
                              <v-row no-gutters>
                                <v-col cols="1">Status</v-col>
                                <v-col cols="11">
                                  <v-chip
                                    :color="
                                      item.data.status == 'submitted'
                                        ? '#006341'
                                        : item.data.status == 'approved'
                                        ? '#006341'
                                        : item.data.status == 'declined'
                                        ? 'red'
                                        : item.data.status == 'revision'
                                        ? '#B3A369'
                                        : '#B3A369'
                                    "
                                    label
                                    text-color="white"
                                  >
                                    {{ item.data.status }}
                                  </v-chip></v-col
                                >
                                <v-col cols="1">Notes</v-col>
                                <v-col cols="11">{{ item.data.notes }}</v-col>
                              </v-row>
                              <v-btn
                                v-if="item.data.status == 'revision'"
                                @click="fetchHistory('proposal', 'update')"
                                dark
                                color="var(--g)"
                                class="text-capitalize mt-2"
                                >Update Propsal</v-btn
                              >
                            </v-card>
                            <v-divider class="mt-2"></v-divider>
                            <v-btn
                              dark
                              color="var(--g)"
                              class="text-capitalize mt-2"
                              @click="fetchHistory('proposal', 'history')"
                              ><v-icon class="mr-2"
                                >mdi-clipboard-text-clock</v-icon
                              >
                              View History</v-btn
                            >
                          </div>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-timeline-item>
              </v-timeline>
            </v-card>
          </div>
        </div>
        <v-card
          v-if="isAllDone"
          flat
          class="mt-5 pa-5 rounded-lg"
          color="rgba(0, 99, 65, 0.2)"
        >
          <div class="d-flex align-center">
            <v-icon class="mr-3" color="#006341">
              mdi-square-edit-outline
            </v-icon>
            <h5>Congratulations! Your proposal has been approved!</h5>
          </div>
          <div class="ml-9">
            <v-btn
              style="text-transform: uppercase"
              color="#006341"
              class="mr-2 btn mt-2"
              :to="`/scholar/tsa/proposal-tsa/monitoring/${dataSet.id}`"
            >
              <h4 style="color: white; font-weight: normal">Progress Report</h4>
            </v-btn>
            <v-btn
              style="text-transform: uppercase"
              color="#006341"
              class="btn mt-2 mr-2"
              :to="`/scholar/tsa/proposal-tsa/responsibility/${dataSet.id}`"
            >
              <h4 style="color: white; font-weight: normal">Final Report</h4>
            </v-btn>
            <v-btn
              style="text-transform: uppercase"
              color="#006341"
              class="btn mt-2"
              :to="`/scholar/tsa/proposal-tsa/documentation/${dataSet.id}`"
            >
              <h4 style="color: white; font-weight: normal">Documentation</h4>
            </v-btn>
          </div>
        </v-card>
      </v-card>
    </div>
    <div v-if="loading">
      <v-card flat class="mt-5 pa-5 rounded-lg" v-for="i in 3" :key="i">
        <v-skeleton-loader
          type="list-item-two-line, article"
        ></v-skeleton-loader>
      </v-card>
    </div>
    <v-snackbar v-model="loadHistory" :timeout="-1"> Loading... </v-snackbar>

    <div class="pa-3">
      <dialog-large
        :d_large="d_large"
        @refetch="fetchData"
        @close="d_large = false"
        :inventory="inventory"
        :title="d_title"
        :type="d_type"
        :hide_title="hide_title"
        line="true"
        :btnTitle="btnTitle"
        :txtTambahan="txtTambahan"
        :title2="d_title2"
      />
      <create-proposal-tsa
        ref="cp"
        :d_cp="d_cp"
        @close="d_cp = false"
        @refetch="fetchData"
        :inventory="inventory"
        :title="d_title"
        :type="d_type"
        :hide_title="hide_title"
        line="true"
        :btnTitle="btnTitle"
        :txtTambahan="txtTambahan"
        :title2="d_title2"
      />
      <history-submission
        :d_his="d_his"
        @refetch="fetchDataProgress"
        @close="d_his = false"
        :inventory="inventory"
        :question="question"
        :type="type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import titlePage from "../../../../components/atom/titlePage.vue";
import HistorySubmission from "../../historySubmission.vue";
import CreateProposalTsa from "./createProposalTsa.vue";

export default {
  name: "detailProposalTsaScholar",
  components: { titlePage, HistorySubmission, CreateProposalTsa },
  computed: {},
  data() {
    return {
      loading: true,
      loadHistory: false,
      dataSet: null,
      d_large: false,
      d_his: false,
      d_cp: false,
      inventory: "",
      d_type: "",
      d_title: "",
      hide_title: "",
      d_title: "",
      d_title2: "",
      txtTambahan: "",
      btnTitle: "",
      progressProposalTsa: null,
      dataLetter: null,
      dataProposal: null,
      isCoverDone: false,
      isAllDone: false,
      nameCategoryTsa: "",
      question: null,
      attr: null,
      type: "",
      lastItem: null,
    };
  },
  mounted() {
    this.fetchData();
    this.getQuestion();
  },
  methods: {
    getQuestion() {
      this.loading = true;
      let data = {
        path: `scholar/tsa-proposal/proposal/question`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          console.log(data);
          data.data.forEach((el) => {
            if (el.attr == "checkbox") {
              if (this.isJson(el.additional)) {
                el["opt"] = JSON.parse(el.additional);
              }
              if (el.id == 13) {
                el[`answer`] = {
                  values: [],
                  competencies: [],
                };
              } else {
                el[`answer`] = [];
              }
            } else if (el.attr == "date") {
              el[`answer`] = "";
              el["menu"] = false;
            } else {
              el[`answer`] = "";
            }
          });
          this.question = data.data;
        })
        .catch((e) => {
          console.log("qesyen", e);
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    isJson(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (error) {
        return false;
      }
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar/tsa-proposal/register?filter[id]=${this.$route.params.idEventProposal}&include=category,proposal`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data[0];
          this.fetchDataProgress();
        })
        .catch((e) => {
          console.log("fetchData", e);

          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    fetchDataProgress() {
      this.loading = true;
      let tempProgress = [];
      let data = {
        path: `scholar/tsa-proposal/progress?tsa_activity_id=${this.dataSet.id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          if (data["review_proposal"].status == "approved") {
            this.isAllDone = true;
          } else {
            this.isAllDone = false;
          }
          for (const item in data) {
            let tempData = null;
            if (data[item].state == true && data[item].status) {
              if (item == "submit_letter" || item == "review_letter") {
                tempData = {
                  data: data[item],
                  key: item,
                  type: "cover_letter",
                };
              } else {
                tempData = {
                  data: data[item],
                  key: item,
                  type: "proposal",
                };
              }
              tempProgress.push(tempData);
            }
          }
          this.loading = false;
          if (tempProgress.length > 0) {
            this.progressProposalTsa = tempProgress;
            let last = tempProgress[tempProgress.length - 1];
            this.lastItem = last;
          }
        })
        .catch((e) => {
          console.log("dataProgress", e);
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    fetchHistory(type, from) {
      this.type = this.lastItem.key;
      this.loadHistory = true;
      let data = {
        path: `tsa-proposal/admin/${type}?tsa_activity_id=${this.dataSet.id}&tsa_category_id=${this.dataSet.tsa_category_id}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          if (from == "history") {
            this.inventory = data;
            this.d_title =
              type == "letter"
                ? "Submission Cover Letter"
                : "Submission Proposal";
            this.d_his = true;
          } else {
            let answer = data[0].answer;
            this.question.forEach((el) => {
              for (let key in answer) {
                if (el.id == key) {
                  el[`answer`] = answer[key];
                }
              }
            });
            this.createProposal("update");
          }
          this.loadHistory = false;
        })
        .catch((e) => {
          console.log("history", e);

          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loadHistory = false;
        });
    },
    createCoverLetter() {
      this.d_type = "c_coverLetterScholar";
      this.d_title = "Instructions";
      this.d_large = true;
      this.hide_title = true;
      this.btnTitle = "";
      this.txtTambahan = "Before submit cover letter";
      this.d_title2 = "Submit Cover Letter";
      this.inventory = this.dataSet;
    },
    updateCoverLetter() {
      let data = {};
      // scholar/tsa-proposal/letter/update
      data = {
        title: this.dataSet.title,
        path: "scholar/tsa-proposal/letter/update",
        body: {
          tsa_activity_id: this.$route.params.idEventProposal,
          type_content: "embed",
          content: "",
          tsa_category_id: this.dataSet.tsa_category_id,
        },
      };
      this.inventory = data;
      this.d_type = "u_coverLetterProposalScholar";
      this.d_title = "Update Cover Letter";
      this.hide_title = true;
      this.btnTitle = "";
      this.txtTambahan = "";
      this.d_title2 = "";
      this.d_large = true;
    },

    createProposal(type) {
      if (type == "update") {
        this.$refs.cp.nextStep();
      }
      let path =
        type == "update"
          ? "scholar/tsa-proposal/proposal/update"
          : "scholar/tsa-proposal/proposal/submit";
      let data = {
        path: path,
        data: this.dataSet,
        form: this.question,
        body: {
          tsa_activity_id: this.dataSet.id,
          tsa_category_id: this.dataSet.tsa_category_id,
        },
      };
      console.log(data);
      this.inventory = data;
      this.d_title =
        type == "update" ? "Update Proposal TSA" : "Create Proposal TSA";
      this.d_cp = true;
    },
  },
};
</script>

<style scoped>
.borderActived {
  border: 1px dashed #006341;
}
.borderNonActived {
  border: 1px dashed rgba(0, 99, 65, 0.4);
}
.txtColor {
  color: #006341;
}
.txtColorDisabled {
  color: rgba(0, 99, 65, 0.4);
}
.border {
  border: 2px solid rgba(0, 0, 0, 0.15);
}

/* ================================================ */
.strip {
  padding: 3px;
  height: 10px;
  width: 100%;
  border-radius: 0 !important;
}
.card_gb {
  position: relative;
  overflow: hidden;
}
.icon_gb {
  position: absolute;
  right: -20px;
  bottom: -20px;
}
.link_temp {
  height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00634166;
  border: 1px #006341 dashed;
  border-radius: 10px;
}
.unlink_temp {
  height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d6e6e1;
  border: 1px #006341 dashed;
  border-radius: 10px;
}
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 10px 10px 0 0 !important;
}
.v-expansion-panel-header {
  min-height: 20px !important;
}
.theme--light.v-timeline:before {
  background: #d8e5e2;
  width: 15px;
  margin-left: -6px;
}
</style>
